// RouteBoard.tsx
import React, { useState } from 'react'
import './RouteBoard.scss'
import { DndProvider, useDrag, useDrop } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'

const ItemTypes = {
  ORDER: 'order',
}

const OrderCard = ({ order }) => {
  const [{ isDragging }, drag] = useDrag(
    () => ({
      type: ItemTypes.ORDER,
      item: { order },
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    }),
    [order],
  )

  return (
    <div ref={drag} className='order-card' style={{ opacity: isDragging ? 0.5 : 1 }}>
      #{order.id} - {order.comment}
    </div>
  )
}

const DriverRoute = ({ route, onDropOrder }) => {
  const [isOpen, setIsOpen] = useState(true)

  const [, drop] = useDrop(
    () => ({
      accept: ItemTypes.ORDER,
      drop: (item) => onDropOrder(item.order, route.id),
    }),
    [route],
  )

  return (
    <div className='route' ref={drop}>
      <div className='route__header' onClick={() => setIsOpen(!isOpen)}>
        <span>{route.driver}</span>
        <button>{isOpen ? '▲' : '▼'}</button>
      </div>
      {isOpen && (
        <div className='route__orders'>
          {route.orders.map((order) => (
            <OrderCard key={order.id} order={order} />
          ))}
        </div>
      )}
    </div>
  )
}

const RouteBoard = () => {
  const [routes, setRoutes] = useState([
    {
      id: 1,
      driver: 'Juan R.',
      orders: [
        { id: 101, comment: 'Call me' },
        { id: 102, comment: '10.30AM' },
      ],
    },
    {
      id: 2,
      driver: 'Marta G.',
      orders: [],
    },
  ])

  const handleDrop = (order, targetRouteId) => {
    setRoutes((prevRoutes) => {
      const newRoutes = prevRoutes.map((route) => {
        return {
          ...route,
          orders: route.orders.filter((o) => o.id !== order.id),
        }
      })

      const target = newRoutes.find((r) => r.id === targetRouteId)
      if (target) target.orders.push(order)

      return newRoutes
    })
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div className='route-board'>
        {routes.map((route) => (
          <DriverRoute key={route.id} route={route} onDropOrder={handleDrop} />
        ))}
      </div>
    </DndProvider>
  )
}

export default RouteBoard
